import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import ClickableListItem from 'LuxKit/List/ClickableListItem'

interface Props {
  isSelected: boolean
  isDisabled: boolean
  onSelect: () => void
  onUnselect: () => void
  departurePort: App.CruiseDepartureRegion
}

function CruiseDepartureSelectListByRegion({ isSelected, isDisabled, onSelect, onUnselect, departurePort }: Props) {
  const intl = useIntl()
  const onSelectByRegionClick = useCallback(() => {
    if (isSelected) {
      onUnselect()
    } else {
      onSelect()
    }
  }, [onSelect, onUnselect, isSelected])

  return <ClickableListItem
    data-testid="cruise-departure-select-select-content-list-all-by"
    onClick={onSelectByRegionClick}
    title={<b>{intl.formatMessage(
      {
        id: 'D7skVg/7uf',
        defaultMessage: 'All {regionName}',
        description: 'List item title to select all departure ports in a region',
      },
      { regionName: departurePort.name },
    )}
    </b>}
    disabled={isDisabled}
    endIcon={<CheckboxButton size="large" checked={isSelected} disabled={isDisabled} />}
  />
}

export default CruiseDepartureSelectListByRegion
